import React from "react";
import moment from "moment";
import get from "lodash.get";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Typography } from "@mui/material";
import StoreModal from "./StoreModal";
import ExchangeModal from "./ExchangeModal";

import logo from "src/assets/logo_white.png";

const Wrapper = styled.div`
  text-align: left;
  background-color: #fff;
  height: 100%;
  width: 100%;

  .coupon-header {
    padding: 22px;
    background-color: #7b7c7e;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .coupon_title {
    color: #7b7c7e;
    margin: 30px 4% 20px 4%;
    > h6 {
      font-size: 1.9rem;
      font-weight: normal;
    }
    .coupon_tag_wrapper > h6 {
      display: flex;
      margin-top: 2px;
      align-items: center;
      .coupon_tag {
        font-size: 14px;
      }
    }
  }
  .coupon_tag {
    color: #fff;
    background-color: #7b7c7e;
    padding: 2px 7px;
    font-size: 1.345rem;
    line-height: 1.5;
    margin-right: 8px;
    &.disabled {
      background-color: #a0a0a2;
      padding: 2px 14px;
    }
  }
  .coupon_instruction {
    margin: 10px 0 30px 0;
    font-size: 1.345rem;
    line-height: 1.5;
  }

  .coupon_detail {
    margin-top: -7px;
    padding: 40px 6%;
    color: #7b7c7e;
    background-color: #ebebeb;
    white-space: pre-line;

    > h6 {
      font-size: 1.345rem;
      line-height: 1.5;
    }
    .coupon_exchange {
      margin: 20px 0;
    }

    .coupon_btn {
      width: 90%;
      margin: 5px 0;
      font-size: 1.5rem;
      font-weight: normal;
      border-radius: 0px;
    }
  }

  .button-wrapper {
    text-align: center;
  }
`;

const Coupon = ({ submitPostCoupon, invalidRedeemCode }) => {
  const couponDetail = useSelector((state) =>
    get(state, "ajax.coupon.data", {})
  );
  const {
    imageUrl,
    title,
    couponLink,
    startTime,
    endTime,
    description = "",
    instruction = "",
    id,
  } = couponDetail;
  const formatTime = (time) => moment(time * 1000).format("YYYY/MM/DD");
  const canExcange =
    moment(endTime * 1000).isAfter(moment()) &&
    moment(startTime * 1000).isBefore(moment());
  return (
    <Wrapper>
      <div className="coupon-header">
        <img alt="logo" src={logo} width="30%" />
      </div>
      <div className="coupon_title">
        <Typography variant="h6">{title}</Typography>
        <div className="coupon_tag_wrapper">
          <Typography variant="h6">
            <div className={`coupon_tag ${couponLink ? "disabled" : ""}`}>
              {couponLink ? "已兌換" : "兌換期間"}
            </div>
            {startTime &&
              endTime &&
              `${formatTime(startTime)}-${formatTime(endTime)}`}
          </Typography>
        </div>
      </div>
      <img alt="imageUrl" src={imageUrl} width="100%" />
      <div className="coupon_detail">
        <Typography
          variant="subtitle1"
          textAlign="center"
          className="coupon_detail_sub"
        >
          {description}
        </Typography>
        <div className="coupon_exchange">
          <Typography variant="string" className="coupon_tag">
            使用說明
          </Typography>
          <div className="coupon_instruction">{instruction}</div>
          <div className="button-wrapper">
            <StoreModal />
            <ExchangeModal
              couponId={id}
              canExcange={canExcange}
              isExchanged={!!couponLink}
              submitPostCoupon={submitPostCoupon}
              invalidRedeemCode={invalidRedeemCode}
            />
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Coupon;
